"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  Cog: ['cog', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M10.546,2.438a1.957,1.957,0,0,0,2.908,0L14.4,1.4a1.959,1.959,0,0,1,3.41,1.413l-.071,1.4A1.958,1.958,0,0,0,19.79,6.267l1.4-.071A1.959,1.959,0,0,1,22.6,9.606l-1.042.94a1.96,1.96,0,0,0,0,2.909l1.042.94a1.959,1.959,0,0,1-1.413,3.41l-1.4-.071a1.958,1.958,0,0,0-2.056,2.056l.071,1.4A1.959,1.959,0,0,1,14.4,22.6l-.941-1.041a1.959,1.959,0,0,0-2.908,0L9.606,22.6A1.959,1.959,0,0,1,6.2,21.192l.072-1.4a1.958,1.958,0,0,0-2.056-2.056l-1.4.071A1.958,1.958,0,0,1,1.4,14.4l1.041-.94a1.96,1.96,0,0,0,0-2.909L1.4,9.606A1.958,1.958,0,0,1,2.809,6.2l1.4.071A1.958,1.958,0,0,0,6.267,4.211L6.2,2.81A1.959,1.959,0,0,1,9.606,1.4Z', 'M7.500 12.001 A4.500 4.500 0 1 0 16.500 12.001 A4.500 4.500 0 1 0 7.500 12.001 Z']],
  CogApproved: ['cog-approved', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M21.684,9.39a1.826,1.826,0,0,1-.539.876l-.972.878a1.828,1.828,0,0,0,0,2.714l.972.878a1.828,1.828,0,0,1-1.319,3.183l-1.308-.067A1.828,1.828,0,0,0,16.6,19.771l.067,1.308A1.828,1.828,0,0,1,13.483,22.4l-.878-.972a1.828,1.828,0,0,0-2.714,0l-.878.972A1.828,1.828,0,0,1,5.83,21.079L5.9,19.771a1.828,1.828,0,0,0-1.919-1.919l-1.308.067a1.828,1.828,0,0,1-1.319-3.183l.972-.878a1.828,1.828,0,0,0,0-2.714l-.972-.878A1.828,1.828,0,0,1,2.67,7.083l1.308.067A1.828,1.828,0,0,0,5.9,5.231L5.83,3.923A1.828,1.828,0,0,1,9.013,2.6l.878.972a1.826,1.826,0,0,0,2.714,0l.878-.972A1.829,1.829,0,0,1,15.54,2.14', 'M7.6,10.641l2.513,3.351a1.5,1.5,0,0,0,2.347.066L23.248,1.251']],
  WenchDouble: ['wench-double', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.4,16.742,16.739,9.4a4.55,4.55,0,0,0,6.066-6.066L21.38,4.763a1.516,1.516,0,0,1-2.144-2.144L20.66,1.194A4.55,4.55,0,0,0,14.594,7.26L7.257,14.6a4.55,4.55,0,0,0-6.066,6.066l1.425-1.424A1.516,1.516,0,0,1,4.76,21.383L3.336,22.808A4.55,4.55,0,0,0,9.4,16.742Z', 'M7.787,9.935l-.53-.53A4.55,4.55,0,0,1,1.191,3.339L2.616,4.763A1.516,1.516,0,0,0,4.76,2.619L3.336,1.194A4.55,4.55,0,0,1,9.4,7.26l.452.453', 'M16.109,13.968l.63.629a4.55,4.55,0,0,1,6.066,6.066L21.38,19.239a1.516,1.516,0,0,0-2.144,2.144l1.424,1.425a4.55,4.55,0,0,1-6.066-6.066l-.629-.63']],
  CogBrowser: ['cog-browser', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M15.75,21.751H21a1.5,1.5,0,0,0,1.5-1.5V3.751a1.5,1.5,0,0,0-1.5-1.5H3a1.5,1.5,0,0,0-1.5,1.5v16.5a1.5,1.5,0,0,0,1.5,1.5H8.25', 'M1.5 6.001L22.5 6.001', 'M8.250 14.701 A3.750 3.750 0 1 0 15.750 14.701 A3.750 3.750 0 1 0 8.250 14.701 Z', 'M12 10.951L12 9.151', 'M12 20.251L12 18.451', 'M15.75 14.701L17.55 14.701', 'M6.45 14.701L8.25 14.701', 'M8.459 10.742L9.566 11.848', 'M15.541 10.742L14.434 11.848', 'M8.459 18.66L9.566 17.553', 'M15.541 18.66L14.434 17.553', 'M12,13.951a.75.75,0,1,1-.75.75.75.75,0,0,1,.75-.75']],
  CogDesktop: ['cog-desktop', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M13.5,18.751a8.934,8.934,0,0,0,1.5,4.5H9a8.934,8.934,0,0,0,1.5-4.5', 'M6.75 23.251L17.25 23.251', 'M0.75 15.751L23.25 15.751', 'M16.5.751h5.25a1.5,1.5,0,0,1,1.5,1.5v15a1.5,1.5,0,0,1-1.5,1.5H2.25a1.5,1.5,0,0,1-1.5-1.5v-15a1.5,1.5,0,0,1,1.5-1.5H7.5', 'M8.250 7.201 A3.750 3.750 0 1 0 15.750 7.201 A3.750 3.750 0 1 0 8.250 7.201 Z', 'M12 3.451L12 1.651', 'M12 12.751L12 10.951', 'M15.75 7.201L17.55 7.201', 'M6.45 7.201L8.25 7.201', 'M8.459 3.242L9.566 4.348', 'M15.541 3.242L14.434 4.348', 'M8.459 11.16L9.566 10.053', 'M15.541 11.16L14.434 10.053', 'M12,6.451a.75.75,0,1,1-.75.75.75.75,0,0,1,.75-.75']],
  CogSearch: ['cog-search', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5',
    transform: 'translate(-1.421 1.665) rotate(-9.05)'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.747 9.814 A9.063 9.063 0 1 0 18.873 9.814 A9.063 9.063 0 1 0 0.747 9.814 Z', 'M16.219 16.222L23.248 23.251', 'M5.998 9.751 A3.750 3.750 0 1 0 13.498 9.751 A3.750 3.750 0 1 0 5.998 9.751 Z', 'M9.748 6.001L9.748 4.201', 'M9.748 15.301L9.748 13.501', 'M13.498 9.751L15.298 9.751', 'M4.198 9.751L5.998 9.751', 'M6.207 5.792L7.313 6.899', 'M13.289 5.792L12.182 6.899', 'M6.207 13.71L7.313 12.604', 'M13.289 13.71L12.182 12.604', 'M9.748,9a.75.75,0,1,1-.75.75A.75.75,0,0,1,9.748,9']],
  Hammer: ['hammer', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5',
    transform: 'translate(-1.475 13.447) rotate(-44.999)'
  }], ['M14.015,13.166,4.369,22.812a1.5,1.5,0,0,1-2.121,0L1.187,21.751a1.5,1.5,0,0,1,0-2.121l9.646-9.646', 'M11.152 1.004 L19.838 1.004 L19.838 16.004 L11.152 16.004 Z']],
  Screwdriver: ['screwdriver', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12.233,13.887l-2.121-2.121a1.5,1.5,0,0,0-2.122,0L1.627,18.13a3,3,0,0,0,4.242,4.242l6.364-6.364A1.5,1.5,0,0,0,12.233,13.887Z', 'M19.029,1.455a1.58,1.58,0,0,1,2.432-.241l1.324,1.324a1.58,1.58,0,0,1-.241,2.432L20.072,6.619A1.941,1.941,0,0,1,17.38,3.927Z', 'M17.623 6.376L11.172 12.827']],
  Wench: ['wench', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M21.214,12.606a6.949,6.949,0,0,0,1.3-8.028L18.964,8.124a1.5,1.5,0,0,1-2.121,0l-.8-.8a1.5,1.5,0,0,1,0-2.122l3.6-3.6a6.947,6.947,0,0,0-9.6,9.087L1.2,19.526a1.542,1.542,0,0,0,0,2.182L2.291,22.8a1.543,1.543,0,0,0,2.183,0l8.836-8.836A6.946,6.946,0,0,0,21.214,12.606Z']],
  ToolBox: ['tool-box', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 6.751 L23.250 6.751 L23.250 21.751 L0.750 21.751 Z', 'M16.5,6.751a4.5,4.5,0,0,0-9,0', 'M0.75 12.751L10.5 12.751', 'M13.5 12.751L23.25 12.751', 'M12,15a1.5,1.5,0,0,1-1.5-1.5V12a1.5,1.5,0,1,1,3,0v1.5A1.5,1.5,0,0,1,12,15Z']],
  Wench1: ['wench-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.4,16.742,16.741,9.4a4.55,4.55,0,0,0,6.066-6.066L21.382,4.763a1.516,1.516,0,0,1-2.144-2.144l1.424-1.425A4.55,4.55,0,0,0,14.6,7.26L7.259,14.6a4.55,4.55,0,0,0-6.066,6.066l1.425-1.424a1.516,1.516,0,0,1,2.144,2.144L3.338,22.808A4.55,4.55,0,0,0,9.4,16.742Z']],
  CogCircle: ['cog-circle', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 12.001 A11.250 11.250 0 1 0 23.250 12.001 A11.250 11.250 0 1 0 0.750 12.001 Z', 'M11.388,5.939a1.136,1.136,0,0,0,1.685,0l.545-.6a1.136,1.136,0,0,1,1.977.819l-.042.812a1.135,1.135,0,0,0,1.192,1.192l.812-.042a1.136,1.136,0,0,1,.819,1.977l-.6.545a1.136,1.136,0,0,0,0,1.685l.6.545a1.136,1.136,0,0,1-.819,1.977l-.812-.042A1.135,1.135,0,0,0,15.553,16l.042.812a1.136,1.136,0,0,1-1.977.819l-.545-.6a1.136,1.136,0,0,0-1.685,0l-.545.6a1.136,1.136,0,0,1-1.977-.819L8.908,16A1.135,1.135,0,0,0,7.716,14.8l-.812.042a1.136,1.136,0,0,1-.819-1.977l.6-.545a1.136,1.136,0,0,0,0-1.685l-.6-.545A1.136,1.136,0,0,1,6.9,8.116l.812.042A1.135,1.135,0,0,0,8.908,6.966l-.042-.812a1.136,1.136,0,0,1,1.977-.819Z', 'M9.980 11.481 A2.250 2.250 0 1 0 14.480 11.481 A2.250 2.250 0 1 0 9.980 11.481 Z']],
  CogPlay: ['cog-play', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M10.544,2.439a1.959,1.959,0,0,0,2.908,0l.94-1.042A1.959,1.959,0,0,1,17.8,2.81l-.072,1.4a1.96,1.96,0,0,0,2.057,2.057l1.4-.072A1.959,1.959,0,0,1,22.6,9.607l-1.042.94a1.959,1.959,0,0,0,0,2.908l1.042.94a1.959,1.959,0,0,1-1.413,3.411l-1.4-.072a1.961,1.961,0,0,0-2.057,2.057l.072,1.4a1.959,1.959,0,0,1-3.411,1.413l-.94-1.042a1.959,1.959,0,0,0-2.908,0L9.6,22.605a1.959,1.959,0,0,1-3.411-1.413l.072-1.4a1.96,1.96,0,0,0-2.057-2.057l-1.4.072A1.959,1.959,0,0,1,1.394,14.4l1.042-.94a1.959,1.959,0,0,0,0-2.908l-1.042-.94A1.959,1.959,0,0,1,2.807,6.2l1.4.072A1.958,1.958,0,0,0,6.265,4.211l-.072-1.4A1.959,1.959,0,0,1,9.6,1.4Z', 'M14.998 12.235L8.998 8.72 8.998 15.751 14.998 12.235z']],
  CogSearch1: ['cog-search-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M17.392 17.395L23.248 23.251', 'M8.998 10.501 A1.500 1.500 0 1 0 11.998 10.501 A1.500 1.500 0 1 0 8.998 10.501 Z', 'M9.224,4.7a1.33,1.33,0,0,1,2.548,0l.442,1.453a.994.994,0,0,0,1.174.681l1.472-.341a1.338,1.338,0,0,1,1.274,2.218L15.1,9.82a1,1,0,0,0,0,1.362l1.03,1.111a1.338,1.338,0,0,1-1.274,2.218l-1.472-.341a.994.994,0,0,0-1.174.681L11.772,16.3a1.33,1.33,0,0,1-2.548,0l-.443-1.453a.993.993,0,0,0-1.173-.681l-1.473.341a1.338,1.338,0,0,1-1.274-2.218l1.031-1.111a1,1,0,0,0,0-1.362L4.861,8.709A1.338,1.338,0,0,1,6.135,6.491l1.473.341a.993.993,0,0,0,1.173-.681Z', 'M0.748 10.501 A9.750 9.750 0 1 0 20.248 10.501 A9.750 9.750 0 1 0 0.748 10.501 Z']],
  CogDouble: ['cog-double', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M5.975,12.151a1.046,1.046,0,0,0,1.551,0l.5-.556a1.045,1.045,0,0,1,1.819.754l-.039.747a1.046,1.046,0,0,0,1.1,1.1l.747-.038a1.045,1.045,0,0,1,.754,1.819l-.556.5a1.046,1.046,0,0,0,0,1.551l.556.5a1.045,1.045,0,0,1-.754,1.819l-.747-.039a1.046,1.046,0,0,0-1.1,1.1l.039.747a1.045,1.045,0,0,1-1.819.754l-.5-.556a1.046,1.046,0,0,0-1.551,0l-.5.556a1.045,1.045,0,0,1-1.819-.754l.038-.747a1.046,1.046,0,0,0-1.1-1.1l-.747.039A1.045,1.045,0,0,1,1.1,18.528l.556-.5a1.046,1.046,0,0,0,0-1.551l-.556-.5a1.045,1.045,0,0,1,.754-1.819l.747.038a1.046,1.046,0,0,0,1.1-1.1l-.038-.747A1.045,1.045,0,0,1,5.474,11.6Z', 'M5.251 17.251 A1.500 1.500 0 1 0 8.251 17.251 A1.500 1.500 0 1 0 5.251 17.251 Z', 'M16.475,1.651a1.046,1.046,0,0,0,1.551,0l.5-.556a1.045,1.045,0,0,1,1.819.754l-.039.747a1.046,1.046,0,0,0,1.1,1.1l.747-.038a1.045,1.045,0,0,1,.754,1.819l-.556.5a1.046,1.046,0,0,0,0,1.551l.556.5a1.045,1.045,0,0,1-.754,1.819l-.747-.039a1.046,1.046,0,0,0-1.1,1.1l.039.747a1.045,1.045,0,0,1-1.819.754l-.5-.556a1.046,1.046,0,0,0-1.551,0l-.5.556a1.045,1.045,0,0,1-1.819-.754l.038-.747a1.046,1.046,0,0,0-1.1-1.1l-.747.039A1.045,1.045,0,0,1,11.6,8.028l.556-.5a1.046,1.046,0,0,0,0-1.551l-.556-.5a1.045,1.045,0,0,1,.754-1.819l.747.038a1.046,1.046,0,0,0,1.1-1.1l-.038-.747A1.045,1.045,0,0,1,15.974,1.1Z', 'M15.751 6.751 A1.500 1.500 0 1 0 18.751 6.751 A1.500 1.500 0 1 0 15.751 6.751 Z']],
  CogHandGive1: ['cog-hand-give-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.75 14.25L0.75 23.25', 'M.75,21.75h16.5a3,3,0,0,0-3-3H10.5a3,3,0,0,0-3-3H.75', 'M6.75 18.75L10.5 18.75', 'M16.474,1.651a1.046,1.046,0,0,0,1.551,0l.5-.556a1.045,1.045,0,0,1,1.819.754l-.038.747a1.044,1.044,0,0,0,1.1,1.1l.747-.039a1.046,1.046,0,0,1,.753,1.82l-.555.5a1.044,1.044,0,0,0,0,1.551l.555.5a1.045,1.045,0,0,1-.753,1.819l-.747-.038a1.044,1.044,0,0,0-1.1,1.1l.038.747a1.045,1.045,0,0,1-1.819.754l-.5-.556a1.046,1.046,0,0,0-1.551,0l-.5.556a1.045,1.045,0,0,1-1.819-.754l.038-.747a1.044,1.044,0,0,0-1.1-1.1l-.747.038A1.045,1.045,0,0,1,11.6,8.027l.555-.5a1.044,1.044,0,0,0,0-1.551l-.555-.5a1.046,1.046,0,0,1,.753-1.82l.747.039a1.044,1.044,0,0,0,1.1-1.1l-.038-.747A1.045,1.045,0,0,1,15.973,1.1Z', 'M15.750 6.750 A1.500 1.500 0 1 0 18.750 6.750 A1.500 1.500 0 1 0 15.750 6.750 Z']],
  HammerWench: ['hammer-wench', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M8.307,10.422,7.259,9.378A4.543,4.543,0,0,1,1.193,3.33L2.618,4.751A1.514,1.514,0,1,0,4.762,2.613L3.338,1.193A4.542,4.542,0,0,1,9.4,7.24l.97.967', 'M15.319,13.136l1.422,1.418A4.543,4.543,0,0,1,22.807,20.6l-1.425-1.42a1.514,1.514,0,0,0-2.144,2.138l1.424,1.42A4.542,4.542,0,0,1,14.6,16.692l-1.422-1.418', 'M1.445,22.6h0a2.233,2.233,0,0,1,0-3.167L6.14,14.747a.75.75,0,0,1,1.059,0l2.118,2.111a.746.746,0,0,1,0,1.056L4.621,22.6A2.251,2.251,0,0,1,1.445,22.6Z', 'M16.586,1.188l6.221,6.2a1.489,1.489,0,0,1,0,2.111L20.69,11.612a1.5,1.5,0,0,1-2.118,0l-6.221-6.2a1.489,1.489,0,0,1,0-2.111l2.117-2.111A1.5,1.5,0,0,1,16.586,1.188Z', 'M15.527 8.577L8.158 15.703']],
  CogDouble2: ['cog-double-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M7.281,9.376a1.308,1.308,0,0,0,1.939,0l.627-.7a1.306,1.306,0,0,1,2.273.942l-.047.934a1.3,1.3,0,0,0,1.371,1.371l.934-.047a1.305,1.305,0,0,1,.941,2.273l-.694.627a1.306,1.306,0,0,0,0,1.939l.694.627a1.305,1.305,0,0,1-.941,2.273l-.934-.047a1.305,1.305,0,0,0-1.371,1.371l.047.934a1.306,1.306,0,0,1-2.273.942l-.627-.7a1.308,1.308,0,0,0-1.939,0l-.627.7a1.306,1.306,0,0,1-2.273-.942l.047-.934a1.307,1.307,0,0,0-1.371-1.371l-.934.047a1.306,1.306,0,0,1-.942-2.273l.695-.627a1.308,1.308,0,0,0,0-1.939l-.695-.627a1.306,1.306,0,0,1,.942-2.273l.934.047a1.305,1.305,0,0,0,1.371-1.371l-.047-.934a1.306,1.306,0,0,1,2.273-.942Z', 'M6.375 15.751 A1.875 1.875 0 1 0 10.125 15.751 A1.875 1.875 0 1 0 6.375 15.751 Z', 'M18.638,5a.375.375,0,1,0,.375.375A.375.375,0,0,0,18.638,5h0', 'M21.194,1.848a.75.75,0,0,1,.971.971l-.5,1.286a.749.749,0,0,0,.229.856l1.075.864a.75.75,0,0,1-.355,1.326l-1.363.211a.749.749,0,0,0-.627.626l-.211,1.364a.75.75,0,0,1-1.326.355l-.864-1.075a.751.751,0,0,0-.856-.23l-1.286.5a.75.75,0,0,1-.971-.971l.5-1.286a.749.749,0,0,0-.229-.856l-1.075-.865A.749.749,0,0,1,14.661,3.6l1.363-.211a.751.751,0,0,0,.627-.627L16.862,1.4a.749.749,0,0,1,1.325-.355l.865,1.075a.75.75,0,0,0,.856.229Z']],
  Cog2: ['cog-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M4.500 12.001 A7.500 7.500 0 1 0 19.500 12.001 A7.500 7.500 0 1 0 4.500 12.001 Z', 'M1.5 12.001L4.5 12.001', 'M19.5 12.001L22.5 12.001', 'M12 1.501L12 4.501', 'M12 19.501L12 22.501', 'M4.575 4.576L6.698 6.698', 'M17.303 17.303L19.425 19.426', 'M19.425 4.576L17.303 6.698', 'M6.698 17.303L4.575 19.426', 'M9.750 12.001 A2.250 2.250 0 1 0 14.250 12.001 A2.250 2.250 0 1 0 9.750 12.001 Z']],
  Hammer1: ['hammer-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5',
    transform: 'translate(-2.542 17.091) rotate(-44.992)'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M1.409,21.592h0a2.249,2.249,0,0,1,0-3.182l4.7-4.7a.752.752,0,0,1,1.061,0l2.121,2.122a.75.75,0,0,1,0,1.061l-4.7,4.7A2.251,2.251,0,0,1,1.409,21.592Z', 'M14.325,2.333l5.834,5.834L15.916,12.41,10.083,6.576a1.5,1.5,0,0,1,0-2.121L12.2,2.333A1.5,1.5,0,0,1,14.325,2.333Z', 'M14.864 9.739 L23.864 9.739 L23.864 13.489 L14.864 13.489 Z', 'M13.265 9.758L8.134 14.667']],
  CogSquare: ['cog-square', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.387,5.939a1.137,1.137,0,0,0,1.686,0l.545-.6a1.135,1.135,0,0,1,1.976.819l-.041.812a1.135,1.135,0,0,0,1.192,1.192l.812-.042a1.135,1.135,0,0,1,.818,1.977l-.6.545a1.134,1.134,0,0,0,0,1.685l.6.545a1.135,1.135,0,0,1-.818,1.977l-.812-.042A1.135,1.135,0,0,0,15.553,16l.041.812a1.135,1.135,0,0,1-1.976.819l-.545-.6a1.137,1.137,0,0,0-1.686,0l-.544.6a1.136,1.136,0,0,1-1.977-.819L8.907,16A1.135,1.135,0,0,0,7.716,14.8l-.812.042a1.136,1.136,0,0,1-.819-1.977l.6-.545a1.136,1.136,0,0,0,0-1.685l-.6-.545A1.136,1.136,0,0,1,6.9,8.116l.812.042A1.135,1.135,0,0,0,8.907,6.966l-.041-.812a1.136,1.136,0,0,1,1.977-.819Z', 'M9.980 11.481 A2.250 2.250 0 1 0 14.480 11.481 A2.250 2.250 0 1 0 9.980 11.481 Z', 'M0.750 0.751 L23.250 0.751 L23.250 23.251 L0.750 23.251 Z']],
  Cog3: ['cog-3', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M10.544,2.439a1.959,1.959,0,0,0,2.908,0l.94-1.042A1.959,1.959,0,0,1,17.8,2.81l-.072,1.4a1.958,1.958,0,0,0,2.057,2.057l1.4-.072A1.959,1.959,0,0,1,22.6,9.607l-1.042.94a1.959,1.959,0,0,0,0,2.908l1.042.94a1.959,1.959,0,0,1-1.413,3.411l-1.4-.072a1.96,1.96,0,0,0-2.057,2.057l.072,1.4a1.959,1.959,0,0,1-3.411,1.413l-.94-1.042a1.959,1.959,0,0,0-2.908,0L9.6,22.605a1.959,1.959,0,0,1-3.411-1.413l.072-1.4a1.961,1.961,0,0,0-2.057-2.057l-1.4.072A1.959,1.959,0,0,1,1.394,14.4l1.042-.94a1.959,1.959,0,0,0,0-2.908l-1.042-.94A1.959,1.959,0,0,1,2.807,6.2l1.4.072A1.96,1.96,0,0,0,6.265,4.211l-.072-1.4A1.959,1.959,0,0,1,9.6,1.4Z', 'M5.998 12.001 A6.000 6.000 0 1 0 17.998 12.001 A6.000 6.000 0 1 0 5.998 12.001 Z', 'M11.998 6.001L11.998 12.001', 'M11.998 12.001L7.398 15.851', 'M11.998 12.001L16.866 15.479']],
  CogHandGive: ['cog-hand-give', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.855 14.251L0.855 23.251', 'M.855,21.751h15a3,3,0,0,0-3-3H9.105a3,3,0,0,0-3-3H.855', 'M6.105 18.751L9.105 18.751', 'M12.854 9.751 A2.250 2.250 0 1 0 17.354 9.751 A2.250 2.250 0 1 0 12.854 9.751 Z', 'M16.925,16.5l.159-1.113A5.946,5.946,0,0,0,19,14.284l1.946.781a1.5,1.5,0,0,0,1.858-.642l.2-.345a1.5,1.5,0,0,0-.373-1.93l-1.633-1.282a5.611,5.611,0,0,0,0-2.231l1.633-1.282A1.5,1.5,0,0,0,23,5.423l-.2-.345a1.5,1.5,0,0,0-1.858-.642L19,5.217a5.946,5.946,0,0,0-1.911-1.1l-.3-2.074A1.5,1.5,0,0,0,15.3.751h-.4A1.5,1.5,0,0,0,13.42,2.038l-.3,2.074a5.941,5.941,0,0,0-1.91,1.1L9.267,4.436a1.5,1.5,0,0,0-1.857.642l-.2.345a1.5,1.5,0,0,0,.372,1.93L9.217,8.635a5.562,5.562,0,0,0,0,2.231L7.583,12.148']]
};
exports["default"] = _default;